import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import AOS from "aos"
import "aos/dist/aos.css"
import NewsStrip from "../components/news-strip"
import MetroFares from "../components/metro-fares"

class ServiceBR2Page extends Component {
  componentDidMount() {
    AOS.init()
    window.addEventListener("load", AOS.refresh)
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000)
  }

  componentDidUpdate() {
    AOS.refresh()
  }

  render() {
    return (
      <Layout>
        <SEO
          title="BR2"
          description="View route information and buy your ticket for the BR2 service operated by Tetley's Coaches."
        />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent">
            <div className="text-center">
              <h1 className="page-content-heading">BR2 service - PM ONLY</h1>
              <p>Swillington Neville Grove Whitecliffe - Brigshaw High School</p>
              <p>Brigshaw High School - Swillington Neville Grove Whitecliffe</p>
            </div>
          </div>

          <div className="body gutter page-content-parent">
            <div className="page-content">
              <div className="page-content__text">
                <h2>Route</h2>
                <h3 style={{ margin: '10px 0'}}>PM route</h3>
                <iframe
                  title="BR2 PM route map"
                  className="route-map"
                  src="https://www.google.com/maps/d/embed?mid=1M5o4aahbGpvKGYXuOwPbR-laTeMFYxs&ehbc=2E312F"
                  width="100%"
                  height="480"
                ></iframe>
                <p>
                  <strong>From</strong> Brigshaw High School
                </p>
                <p>
                From Brigshaw Lane, Preston Lane, Whitehouse Lane, Goody Cross Lane, Wakefield Road, Church Lane, Neville Grove.
                </p>
              </div>
              <div className="page-content__text">
                <h2>Timetable</h2>

                <table className="timetable">
                  <thead>
                    <tr>
                      <th colSpan="3">Afternoon</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Brigshaw High School</td>
                      <td>DEP</td>
                      <td>1510</td>
                    </tr>
                    <tr>
                      <td>Great Preston Corner</td>
                      <td>DEP</td>
                      <td>1513</td>
                    </tr>
                    <tr>
                      <td>Swillington Church</td>
                      <td>DEP</td>
                      <td>1521</td>
                    </tr>
                    <tr>
                      <td>Swillington Neville Grove Whitecliffe</td>
                      <td>ARR</td>
                      <td>1525</td>
                    </tr>
                  </tbody>
                </table>

                <MetroFares />
              </div>
            </div>
          </div>
        </div>

        <NewsStrip />
      </Layout>
    )
  }
}

export default ServiceBR2Page
